<template>
  <v-menu
    v-if="$vuetify.breakpoint.smAndDown || this.isAdmin"
    bottom
    min-width="200px"
    rounded
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list-item-content class="justify-center py-0">
        <div class="mx-auto text-center">
          <router-link
            v-if="$vuetify.breakpoint.xs"
            class="text-decoration-none"
            :to="{ name: 'apps-list' }"
          >
            <v-btn depressed text block large>
              <v-icon left>$mdi-file-multiple</v-icon>
              {{ $t("layout.navbar.apps") }}
            </v-btn>
          </router-link>

          <router-link
            v-if="$vuetify.breakpoint.smAndDown"
            class="text-decoration-none"
            :to="{ name: 'stats' }"
          >
            <v-btn depressed text block large>
              <v-icon left>$mdi-chart-bar</v-icon>
              {{ $t("layout.navbar.stats") }}
            </v-btn>
          </router-link>

          <slot v-if="this.isAdmin">
            <router-link
              v-if="$vuetify.breakpoint.mdAndDown"
              class="text-decoration-none"
              :to="{ name: 'moderators-list' }"
            >
              <v-btn depressed text block large>
                <v-icon left>$mdi-account-multiple</v-icon>
                {{ $t("layout.navbar.moderators") }}
              </v-btn>
            </router-link>

            <router-link
              v-if="$vuetify.breakpoint.mdAndDown"
              class="text-decoration-none"
              :to="{ name: 'settings' }"
            >
              <v-btn depressed text block large>
                <v-icon left>$mdi-cog</v-icon>
                {{ $t("layout.navbar.settings") }}
              </v-btn>
            </router-link>

            <router-link
              class="text-decoration-none"
              :to="{ name: 'institutes' }"
            >
              <v-btn depressed text block large>
                <v-icon left>$mdi-database</v-icon>
                {{ $t("layout.navbar.institutes") }}
              </v-btn>
            </router-link>

            <router-link class="text-decoration-none" :to="{ name: 'paths' }">
              <v-btn depressed text block large>
                <v-icon left>$mdi-book-education</v-icon>
                {{ $t("layout.navbar.paths") }}
              </v-btn>
            </router-link>

            <router-link class="text-decoration-none" :to="{ name: 'papers' }">
              <v-btn depressed text block large>
                <v-icon left>$mdi-file-document</v-icon>
                {{ $t("layout.navbar.papers") }}
              </v-btn>
            </router-link>

            <router-link
              class="text-decoration-none"
              :to="{ name: 'baseachs' }"
            >
              <v-btn depressed text block large>
                <v-icon left>$mdi-license</v-icon>
                {{ $t("layout.navbar.achs_base") }}
              </v-btn>
            </router-link>

            <router-link
              class="text-decoration-none"
              :to="{ name: 'specachs' }"
            >
              <v-btn depressed text block large>
                <v-icon left>$mdi-seal</v-icon>
                {{ $t("layout.navbar.achs_spec") }}
              </v-btn>
            </router-link>
          </slot>
        </div>
      </v-list-item-content>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  computed: {
    /**
     * Check if current user is Admin
     */
    isAdmin() {
      return this.$auth.user().roles.includes("admin");
    },

    initials() {
      // Admin is no one
      if (this.isAdmin) return this.$t("account.admin_initials");

      if (this.fioShort.includes(" "))
        return (
          this.fioShort.substr(this.fioShort.indexOf(" ") + 1, 1) +
          this.fioShort[0]
        );

      return this.fioShort[0];
    },

    fioShort() {
      // Admin is no one
      if (this.isAdmin) return this.$t("account.admin");

      const fio = this.$auth.user().fio;

      const arr = fio.split(" ");
      let fioShort = arr[0];
      for (let i = 1; i < arr.length; i++) {
        if (i === 1) fioShort += " ";
        fioShort += arr[i][0] + ".";
      }

      return fioShort;
    },

    login() {
      return this.$auth.user().login;
    },
  },

  methods: {
    /**
     * Log out of the system
     */
    logout() {
      this.$store.dispatch("auth/logout").then(null, e => {
        this.HandleError(e);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration-line: none;

  .v-btn {
    font-size: 15px;
    color: #7e7e7e;
    text-transform: none;
    letter-spacing: -0.03em;

    .v-icon {
      width: 24px;
    }

    &:hover {
      color: #37b34a;
    }
  }

  &.router-link-active {
    .v-btn {
      color: #008a15;
    }
  }
}
</style>
